// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Encounter Detail / Encounter Workspace only. Namespaced so list/chart stay unchanged. */

.emr-encdetail,
.emr-encdetail *,
.emr-encdetail *::before,
.emr-encdetail *::after,
.emr-encdetail-select,
.emr-encdetail-select *,
.emr-encdetail-dialog,
.emr-encdetail-dialog *,
.emr-encdetail-pane,
.emr-encdetail-pane *,
.emr-encdetail-pane *::before,
.emr-encdetail-pane *::after {
  border-radius: 0 !important;
}

.emr-mz-dashboard:has(.emr-encdetail) {
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
}

.emr-mz-dashboard:has(.emr-encdetail) > .flex-1 {
  min-height: 0;
  overflow: hidden;
}

/* The app header scrolls its own overflow, so flex would otherwise squash it. */
.emr-mz-dashboard:has(.emr-encdetail) .emr-mz-header {
  flex-shrink: 0;
}

.emr-mz-dashboard .emr-mz-main:has(.emr-encdetail) {
  padding: 10px 12px 12px !important;
  max-width: none;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1 auto;
}

.emr-encdetail {
  --emr-encdetail-primary: #1976d2;
  --emr-encdetail-primary-dark: #0d47a1;
  --emr-encdetail-text: #212121;
  --emr-encdetail-muted: #616161;
  --emr-encdetail-border: #e0e0e0;
  --emr-encdetail-surface: #ffffff;
  --emr-encdetail-close: #0d5c4d;
  --emr-encdetail-close-dark: #0a4b3f;
  max-width: none;
  margin: 0;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  color: var(--emr-encdetail-text);
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}

.emr-encdetail__pagehead {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
  min-width: 0;
  flex-shrink: 0;
}

.emr-mz-dashboard .emr-encdetail__title,
.emr-encdetail__title {
  margin: 0;
  font-size: var(--emr-type-page-title) !important;
  font-weight: 600;
  line-height: 1.25;
  color: var(--emr-encdetail-text);
}

.emr-encdetail__subtitle {
  margin: 2px 0 0;
  font-size: var(--emr-type-helper);
  font-weight: 400;
  color: var(--emr-encdetail-muted);
}

.emr-encdetail a.emr-encdetail__back,
.emr-encdetail__back {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  margin-top: 4px;
  font-size: var(--emr-type-label);
  font-weight: 600;
  color: var(--emr-encdetail-primary) !important;
  text-decoration: none;
}

.emr-encdetail__back:hover {
  text-decoration: underline;
}

.emr-encdetail__back-icon {
  width: 14px;
  height: 14px;
}

.emr-encdetail__head-actions {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  gap: 8px;
}

.emr-mz-dashboard .btn.emr-encdetail__secondary,
.emr-encdetail__secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 12px;
  margin: 0;
  background: #fff !important;
  color: var(--emr-encdetail-primary) !important;
  border: 1px solid var(--emr-encdetail-border);
  box-shadow: none;
}

.emr-mz-dashboard .btn.emr-encdetail__secondary:hover,
.emr-encdetail__secondary:hover {
  border-color: var(--emr-encdetail-primary);
  background: #e3f2fd !important;
}

.emr-mz-dashboard .btn.emr-encdetail__primary,
.emr-encdetail__primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  margin: 0;
  background: var(--emr-encdetail-primary) !important;
  color: #fff !important;
  border: 1px solid var(--emr-encdetail-primary);
  box-shadow: none;
}

.emr-mz-dashboard .btn.emr-encdetail__primary:hover,
.emr-mz-dashboard .btn.emr-encdetail__primary:focus,
.emr-encdetail__primary:hover,
.emr-encdetail__primary:focus {
  background: var(--emr-encdetail-primary-dark) !important;
  border-color: var(--emr-encdetail-primary-dark);
}

.emr-mz-dashboard .btn.emr-encdetail__close,
.emr-encdetail__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  min-width: 10.5rem;
  padding: 0 14px;
  margin: 0;
  background: var(--emr-encdetail-close) !important;
  color: #fff !important;
  border: 1px solid var(--emr-encdetail-close);
  box-shadow: none;
  font-size: var(--emr-type-button-compact);
  font-weight: var(--emr-weight-title);
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.emr-mz-dashboard .btn.emr-encdetail__close:hover,
.emr-encdetail__close:hover {
  background: var(--emr-encdetail-close-dark) !important;
  border-color: var(--emr-encdetail-close-dark);
}

.emr-mz-dashboard .btn.emr-encdetail__reopen,
.emr-encdetail__reopen {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  min-width: 10.5rem;
  padding: 0 14px;
  margin: 0;
  background: #fff !important;
  color: var(--emr-encdetail-close) !important;
  border: 1px solid var(--emr-encdetail-close);
  box-shadow: none;
  font-size: var(--emr-type-button-compact);
  font-weight: var(--emr-weight-title);
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.emr-mz-dashboard .btn.emr-encdetail__reopen:hover,
.emr-encdetail__reopen:hover {
  background: #eefaf5 !important;
}

.emr-mz-dashboard .btn.emr-encdetail__primary:disabled,
.emr-mz-dashboard .btn.emr-encdetail__secondary:disabled,
.emr-mz-dashboard .btn.emr-encdetail__close:disabled,
.emr-mz-dashboard .btn.emr-encdetail__reopen:disabled,
.emr-encdetail__primary:disabled,
.emr-encdetail__secondary:disabled {
  opacity: 0.55;
  pointer-events: none;
}

.emr-encdetail__icon {
  width: 14px;
  height: 14px;
}

.emr-encdetail__modules {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  min-height: 0;
  flex: 1 1 auto;
  overflow: hidden;
}

.emr-encdetail__module {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.emr-encdetail__section {
  margin: 0;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  background: var(--emr-encdetail-surface);
  border: 1px solid var(--emr-encdetail-border);
  box-shadow: none;
  padding: 8px 12px 10px;
}

.emr-encdetail__section-title {
  margin: 0 0 6px;
  font-size: var(--emr-type-metadata) !important;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--emr-encdetail-muted);
}

.emr-encdetail__facts {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 6px 16px;
  min-width: 0;
}

.emr-encdetail__fact-label {
  font-size: var(--emr-type-label);
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--emr-encdetail-muted);
  line-height: 1.2;
}

.emr-encdetail__fact-value {
  margin-top: 1px;
  font-size: var(--emr-type-body);
  font-weight: 600;
  color: var(--emr-encdetail-text);
  line-height: var(--emr-leading-compact);
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.emr-encdetail__patient-head {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 12px;
  padding: 6px 8px;
  margin-bottom: 6px;
  background: #fafbfc;
  border: 1px solid var(--emr-encdetail-border);
}

/* Compact patient identity, always visible above the encounter bar in the
   Documentation column — even when the Patient Chart column is collapsed. */
.emr-encdetail__identity-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #fafbfc;
  border-bottom: 1px solid var(--emr-encdetail-border);
}

.emr-encdetail__identity-expand {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  height: 28px;
  width: 28px;
  padding: 0;
  margin: 0;
  background: #fff;
  color: var(--emr-encdetail-primary);
  border: 1px solid var(--emr-encdetail-border);
  cursor: pointer;
}

.emr-encdetail__identity-expand:hover {
  background: #e3f2fd;
  border-color: var(--emr-encdetail-primary);
}

.emr-encdetail__identity-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.emr-encdetail__identity-name {
  font-size: var(--emr-type-section-title);
  font-weight: var(--emr-weight-title);
  color: var(--emr-encdetail-text);
}

.emr-encdetail__identity-meta {
  margin-top: 2px;
  font-size: var(--emr-type-helper);
  font-weight: 600;
  color: var(--emr-encdetail-muted);
}

.emr-encdetail__identity-sep {
  margin: 0 6px;
  color: var(--emr-encdetail-border);
}

.emr-encdetail__patient-name {
  font-size: var(--emr-type-body);
  font-weight: 600;
  color: var(--emr-encdetail-text);
}

.emr-encdetail__chip {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  font-size: var(--emr-type-metadata);
  font-weight: 600;
  border: 0;
}

.emr-encdetail__chip--active {
  background: #e8f5e9;
  color: #2e7d32;
}

.emr-encdetail__chip--inactive {
  background: #eceff1;
  color: #546e7a;
}

.emr-encdetail__chip--finished {
  background: #e8f5e9;
  color: #2e7d32;
}

.emr-encdetail__chip--progress {
  background: #e3f2fd;
  color: #0d47a1;
}

.emr-encdetail__chip--neutral {
  background: #eceff1;
  color: #455a64;
}

.emr-encdetail__chip--signed {
  background: #e8f5e9;
  color: #2e7d32;
}

.emr-encdetail__chip--draft {
  background: #fff8e1;
  color: #ef6c00;
}

.emr-encdetail__hint {
  margin: 0;
  font-size: var(--emr-type-helper);
  color: var(--emr-encdetail-muted);
}

.emr-encdetail__rows {
  display: grid;
  gap: 4px;
}

.emr-encdetail__row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
  font-size: var(--emr-type-body);
}

.emr-encdetail__row dt {
  color: var(--emr-encdetail-muted);
  font-weight: 400;
}

.emr-encdetail__row dd {
  margin: 0;
  font-weight: 600;
  color: var(--emr-encdetail-text);
  text-align: right;
  min-width: 0;
}

.emr-encdetail__muted {
  margin: 6px 0 0;
  font-size: var(--emr-type-helper);
  color: var(--emr-encdetail-muted);
}

.emr-encdetail__focus-list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 6px;
}

.emr-encdetail__focus-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  font-size: var(--emr-type-body);
}

.emr-encdetail__focus-code {
  flex-shrink: 0;
  font-size: var(--emr-type-metadata);
  color: var(--emr-encdetail-muted);
}

.emr-encdetail__workspace {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
}

/*
 * \`.emr-mz-dashboard section\` forces display:block at a higher specificity than
 * Tailwind's .flex, so the pane must claim its flex column here. Without this
 * the height chain down to .emr-note-rtf__surface is not definite.
 */
.emr-mz-dashboard .emr-encdetail__pane,
.emr-encdetail__pane {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: var(--emr-encdetail-surface);
  border: 1px solid var(--emr-encdetail-border);
  box-shadow: none;
}

.emr-encdetail__pane-head {
  flex-shrink: 0;
  padding: 6px 10px;
  border-bottom: 1px solid var(--emr-encdetail-border);
}

/* Patient Chart tab strip + collapse control, at the top of the left column. */
.emr-encdetail__chart-tabs-row {
  display: flex;
  flex-shrink: 0;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  border-bottom: 1px solid var(--emr-encdetail-border);
}

.emr-encdetail__chart-tabs-row .chart-subtabs {
  flex: 1 1 auto;
  min-width: 0;
}

.emr-encdetail__chart-collapse-btn {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  margin: 4px 6px 0 0;
  padding: 0;
  background: #fff;
  color: var(--emr-encdetail-muted);
  border: 1px solid var(--emr-encdetail-border);
  cursor: pointer;
}

.emr-encdetail__chart-collapse-btn:hover {
  background: #e3f2fd;
  color: var(--emr-encdetail-primary-dark);
  border-color: var(--emr-encdetail-primary);
}

.emr-encdetail__chart-body {
  display: flex;
  flex-direction: column;
}

.emr-encdetail__pane-body {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  padding: 8px;
}

/*
 * The Notes pane never scrolls its own note content: the contenteditable RTF
 * surface is the note scrollport. This keeps a definite height chain from the
 * 100vh shell down to .emr-note-rtf__surface.
 */
.emr-encdetail__pane-body--notes {
  overflow: hidden;
}

.emr-encdetail__pane-title {
  margin: 0;
  font-size: var(--emr-type-metadata) !important;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--emr-encdetail-muted);
}

.emr-encdetail__pane-toggle {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  margin: 0;
  border: 0;
  background: #fff;
  text-align: left;
  cursor: pointer;
}

.emr-encdetail__pane-toggle-meta {
  font-size: var(--emr-type-metadata);
  color: var(--emr-encdetail-muted);
}

.emr-encdetail__restore {
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: var(--emr-encdetail-muted);
  border: 0;
  cursor: pointer;
}

.emr-encdetail__restore:hover {
  background: #e3f2fd;
  color: var(--emr-encdetail-primary-dark);
}

.emr-encdetail__restore-label {
  margin-top: 12px;
  font-size: var(--emr-type-micro);
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: inherit;
  writing-mode: vertical-rl;
}

.emr-encdetail__divider {
  position: relative;
  z-index: 10;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background: transparent;
  cursor: col-resize;
}

.emr-encdetail__divider-line {
  height: 100%;
  width: 1px;
  background: var(--emr-encdetail-border);
}

.emr-encdetail__divider:hover .emr-encdetail__divider-line {
  background: #90a4ae;
}

.emr-encdetail__divider-grip {
  pointer-events: none;
  position: absolute;
  height: 32px;
  width: 4px;
  background: #b0bec5;
  opacity: 0;
}

.emr-encdetail__divider:hover .emr-encdetail__divider-grip {
  opacity: 1;
}

.emr-encdetail__status-msg {
  padding: 28px 16px;
  text-align: center;
  font-size: var(--emr-type-body);
  color: var(--emr-encdetail-muted);
}

.emr-encdetail__empty {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 28px 16px;
  text-align: center;
  border: 1px dashed var(--emr-encdetail-border);
  background: #fff;
}

.emr-encdetail__empty-title {
  margin: 0;
  font-size: var(--emr-type-label);
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--emr-encdetail-text);
}

.emr-encdetail__empty-copy {
  margin: 6px 0 0;
  font-size: var(--emr-type-helper);
  color: var(--emr-encdetail-muted);
}

.emr-encdetail__empty-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
}

/* Compact encounter identification/status strip at the top of the main workspace. */
.emr-encdetail__encounter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 12px;
  background: #fafbfc;
  border-bottom: 1px solid var(--emr-encdetail-border);
}

.emr-encdetail__encounter-bar-facts {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.emr-encdetail__encounter-bar-label {
  font-size: var(--emr-type-label);
  font-weight: var(--emr-weight-label);
  color: var(--emr-encdetail-text);
  white-space: nowrap;
}

.emr-encdetail__encounter-bar-value {
  font-size: var(--emr-type-body);
  font-weight: 600;
  color: var(--emr-encdetail-text);
  white-space: nowrap;
}

.emr-encdetail__encounter-bar-sep {
  color: var(--emr-encdetail-border);
}

.emr-encdetail__encounter-bar-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.emr-encdetail__notes-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 2px 6px 0;
}

.emr-encdetail__notes-title {
  font-size: var(--emr-type-card-title);
  font-weight: 600;
  color: var(--emr-encdetail-text);
}

.emr-encdetail__notes-tabs {
  display: flex;
  align-items: flex-end;
  gap: 2px;
  min-width: 0;
}

.emr-encdetail__notes-tab {
  padding: 5px 12px;
  margin: 0;
  border: 1px solid transparent;
  border-bottom: 0;
  background: transparent;
  color: var(--emr-encdetail-muted);
  font-size: var(--emr-type-button-compact);
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  cursor: pointer;
}

.emr-encdetail__notes-tab:hover {
  color: var(--emr-encdetail-primary-dark);
}

.emr-encdetail__notes-tab--active {
  margin-bottom: -1px;
  border-color: var(--emr-encdetail-border);
  background: #fff;
  color: var(--emr-encdetail-primary-dark);
}

/* Right-side collapsible Diagnosis / CPT Code / Order panel. */
.emr-encdetail__coding {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
}

.emr-encdetail__coding-tabs-row {
  display: flex;
  flex-shrink: 0;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  border-bottom: 1px solid var(--emr-encdetail-border);
}

.emr-encdetail__coding-tabs {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 2px;
  min-width: 0;
  padding: 6px 6px 0;
}

.emr-encdetail__coding-tab {
  padding: 5px 12px;
  margin: 0;
  border: 1px solid transparent;
  border-bottom: 0;
  background: transparent;
  color: var(--emr-encdetail-muted);
  font-size: var(--emr-type-button-compact);
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer;
}

.emr-encdetail__coding-tab:hover {
  color: var(--emr-encdetail-primary-dark);
}

.emr-encdetail__coding-tab--active {
  margin-bottom: -1px;
  border-color: var(--emr-encdetail-border);
  background: #fff;
  color: var(--emr-encdetail-primary-dark);
}

.emr-encdetail__coding-body {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  padding: 12px;
  background: #fff;
}

.emr-encdetail__coding-empty {
  padding: 28px 16px;
  text-align: center;
  font-size: var(--emr-type-helper);
  color: var(--emr-encdetail-muted);
}

.emr-mz-dashboard .btn.emr-encdetail__new-note,
.emr-encdetail__new-note {
  height: 28px;
  padding: 0 10px;
  font-size: var(--emr-type-button-compact);
}

.emr-encdetail__notes {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  min-height: 0;
  width: 100%;
}

.emr-encdetail__notes-panel {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  min-height: 0;
  /* Fallback only: on very short viewports the editor keeps its min height and
     this panel scrolls instead of collapsing the writing area to nothing. */
  overflow-y: auto;
}

.emr-encdetail__notes-panel--scroll {
  overflow-y: auto;
}

.emr-encdetail__notes-panel--empty {
  justify-content: center;
  align-items: center;
}

.emr-encdetail__current {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  background: #fafbfc;
  border: 1px solid var(--emr-encdetail-border);
}

.emr-encdetail__current-title {
  font-size: var(--emr-type-card-title);
  font-weight: 600;
  color: var(--emr-encdetail-text);
}

.emr-encdetail__current-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 2px;
  font-size: var(--emr-type-helper);
  color: var(--emr-encdetail-muted);
}

.emr-encdetail__current-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.emr-encdetail__editor {
  min-height: 16rem;
  width: 100%;
  padding: 8px 10px;
  border: 1px solid var(--emr-encdetail-border);
  background: #fff;
  font-size: var(--emr-type-body);
  line-height: 1.45;
  color: var(--emr-encdetail-text);
  resize: vertical;
}

.emr-encdetail__editor:focus {
  border-color: var(--emr-encdetail-primary);
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.18);
  outline: none;
}

.emr-encdetail__editor[readonly],
.emr-encdetail__editor--locked {
  background: #fafbfc;
  cursor: not-allowed;
}

.emr-encdetail__editor--rtf {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  padding: 0;
  resize: none;
  min-height: 0;
  overflow: hidden;
}

.emr-encdetail__editor--rtf.emr-encdetail__editor--locked {
  cursor: default;
}

.emr-note-rtf {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  width: 100%;
  height: 100%;
}

.emr-note-rtf__toolbar {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  align-items: center;
  gap: 1px;
  min-height: 32px;
  padding: 2px 6px;
  border-bottom: 1px solid var(--emr-encdetail-border);
  background: #f8fafc;
}

.emr-note-rtf__label {
  margin-right: 4px;
  padding-right: 6px;
  border-right: 1px solid #e2e8f0;
  color: #64748b;
  font-size: var(--emr-type-metadata);
  font-weight: var(--emr-weight-title);
  letter-spacing: 0.04em;
  line-height: 1;
  white-space: nowrap;
}

.emr-note-rtf__sep {
  width: 1px;
  height: 16px;
  margin: 0 4px;
  background: #e2e8f0;
}

.emr-note-rtf__select {
  height: 26px;
  width: auto;
  max-width: 88px;
  margin: 0 2px;
  padding: 0 4px;
  border: 1px solid #e2e8f0;
  border-radius: 3px;
  background: #fff;
  color: #334155;
  font-size: var(--emr-type-label);
}

.emr-note-rtf__extra {
  margin-left: auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding: 2px 0 2px 6px;
}

.emr-note-rtf__surface {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 12px 14px;
  color: var(--emr-encdetail-text);
  font-size: var(--emr-type-body);
  line-height: 1.55;
  outline: none;
}

.emr-note-rtf__surface:empty:before {
  content: attr(data-placeholder);
  color: #94a3b8;
  white-space: pre-wrap;
  pointer-events: none;
}

.emr-note-rtf__surface--locked {
  background: #fafbfc;
  cursor: default;
}

.emr-note-rtf__surface p,
.emr-note-rtf__surface div {
  margin: 0 0 0.25em;
}

.emr-note-rtf__surface ul,
.emr-note-rtf__surface ol {
  margin: 0 0 0.25em 1.2em;
  padding: 0;
}

.emr-encdetail__notes-body {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  min-height: 0;
}

.emr-encdetail__notes-main {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
}

.emr-encdetail__editor-wrap {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  min-height: 12rem;
}

.emr-encdetail__autosave {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 12px;
  padding-top: 4px;
  font-size: var(--emr-type-metadata);
  color: var(--emr-encdetail-muted);
}

.emr-encdetail__autosave-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #66bb6a;
}

.emr-encdetail__autosave-dot--off {
  background: #bdbdbd;
}

.emr-encdetail__orders {
  padding: 16px 12px;
  text-align: center;
  border: 1px dashed var(--emr-encdetail-border);
  background: #fff;
}

.emr-encdetail__orders-icon {
  display: flex;
  width: 32px;
  height: 32px;
  margin: 0 auto 8px;
  align-items: center;
  justify-content: center;
  background: #e3f2fd;
  color: var(--emr-encdetail-primary);
}

.emr-encdetail__orders h2 {
  margin: 0;
  font-size: var(--emr-type-card-title) !important;
  font-weight: 600;
  color: var(--emr-encdetail-text);
}

.emr-encdetail-dialog {
  border: 1px solid var(--emr-encdetail-border, #e0e0e0) !important;
  border-radius: 0 !important;
  background: #fff !important;
  box-shadow: none !important;
}

.emr-encdetail-select {
  border-radius: 0 !important;
  border: 1px solid var(--emr-encdetail-border, #e0e0e0) !important;
  background: #fff !important;
  box-shadow: none !important;
}

/* Nested clinical cards inside Notes inherit sharp Materialize modules. */
.emr-encdetail [data-testid="encounter-screen-soap-editor"],
.emr-encdetail [data-testid="encounter-screen-note-list"],
.emr-encdetail [data-testid="encounter-screen-diagnosis-workspace"] section,
.emr-encdetail [data-testid="encounter-screen-cpt"] {
  border-color: var(--emr-encdetail-border) !important;
  box-shadow: none !important;
}

.emr-encdetail [data-testid="encounter-screen-soap-editor"] {
  min-height: 0;
}

@media only screen and (min-width: 601px) {
  .emr-encdetail__facts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media only screen and (min-width: 1024px) {
  .emr-encdetail__module {
    height: 100%;
  }

  .emr-encdetail__facts {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media only screen and (min-width: 1440px) {
  .emr-encdetail__facts {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media only screen and (max-width: 1023px) {
  .emr-mz-dashboard:has(.emr-encdetail) {
    height: auto;
    max-height: none;
    overflow: visible;
  }

  .emr-mz-dashboard:has(.emr-encdetail) > .flex-1 {
    min-height: 0;
    overflow: visible;
  }

  .emr-mz-dashboard .emr-mz-main:has(.emr-encdetail) {
    overflow: visible;
    display: block;
    min-height: 0;
  }

  .emr-encdetail {
    height: auto;
    max-height: none;
    overflow: visible;
    min-height: 0;
  }

  .emr-encdetail__modules,
  .emr-encdetail__workspace {
    overflow: visible;
    min-height: 0;
    flex: none;
  }

  /*
   * Stacked mode has no definite height chain, so give the editor an explicit
   * viewport share. Without this the contenteditable grows to its content and
   * the page becomes the note scrollport.
   */
  .emr-encdetail__notes-panel {
    overflow: visible;
  }

  .emr-encdetail__editor-wrap {
    flex: none;
    height: 60vh;
    min-height: 20rem;
  }
}

@media only screen and (max-width: 899px) {
  .emr-encdetail__pagehead {
    flex-wrap: wrap;
  }
}

@media only screen and (max-width: 600px) {
  .emr-encdetail__pagehead {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .emr-mz-dashboard .emr-encdetail__title,
  .emr-encdetail__title {
    font-size: var(--emr-type-page-title-compact) !important;
  }

  .emr-encdetail__head-actions,
  .emr-encdetail__current-actions {
    width: 100%;
  }

  .emr-mz-dashboard .btn.emr-encdetail__primary,
  .emr-mz-dashboard .btn.emr-encdetail__secondary,
  .emr-mz-dashboard .btn.emr-encdetail__close,
  .emr-mz-dashboard .btn.emr-encdetail__reopen,
  .emr-encdetail__primary,
  .emr-encdetail__secondary,
  .emr-encdetail__close,
  .emr-encdetail__reopen {
    flex: 1 1 auto;
    width: auto;
    min-width: 0;
  }

  .emr-encdetail__facts {
    grid-template-columns: minmax(0, 1fr);
  }

  .emr-encdetail__section {
    padding: 8px 10px;
  }

  .emr-encdetail {
    min-height: 0;
  }
}

/* Encounter Detail now sits in Materialize chrome; keep the print article hidden on screen. */
.emr-mz-dashboard article.note-print-root {
  display: none !important;
}

@media print {
  .emr-mz-dashboard article.note-print-root {
    display: block !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/emr-encounter-detail.css"],"names":[],"mappings":"AAAA,0FAA0F;;AAE1F;;;;;;;;;;;;EAYE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA,gFAAgF;AAChF;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,8BAA8B;EAC9B,mCAAmC;EACnC,eAAe;EACf,SAAS;EACT,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,SAAS;EACT,gDAAgD;EAChD,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,8CAA8C;EAC9C,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;;EAEE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,SAAS;EACT,mDAAmD;EACnD,sBAAsB;EACtB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;;;;EAIE,wDAAwD;EACxD,+CAA+C;AACjD;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,iDAAiD;EACjD,sBAAsB;EACtB,4CAA4C;EAC5C,gBAAgB;EAChB,yCAAyC;EACzC,oCAAoC;EACpC,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,sDAAsD;EACtD,6CAA6C;AAC/C;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,4CAA4C;EAC5C,4CAA4C;EAC5C,gBAAgB;EAChB,yCAAyC;EACzC,oCAAoC;EACpC,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;;;;;EAME,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;EACxC,6CAA6C;EAC7C,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,8CAA8C;EAC9C,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,gCAAgC;EAChC,uCAAuC;EACvC,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;4EAC4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,mCAAmC;EACnC,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;;EAIE;AACF;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,wCAAwC;EACxC,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oDAAoD;AACtD;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,oDAAoD;AACtD;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,iCAAiC;EACjC,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;;;;EAIE;AACF;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,8CAA8C;EAC9C,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iCAAiC;EACjC,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,oFAAoF;AACpF;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;EACjC,yCAAyC;EACzC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;EACjC,yCAAyC;EACzC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb;4EAC0E;EAC1E,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,6CAA6C;EAC7C,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,8CAA8C;EAC9C,aAAa;AACf;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;EACd,mCAAmC;EACnC,oCAAoC;EACpC,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,gDAAgD;EAChD,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,iEAAiE;EACjE,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,iEAAiE;EACjE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,0EAA0E;AAC1E;;;;EAIE,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;EACf;;EAEA;;IAEE,iBAAiB;IACjB,aAAa;IACb,UAAU;EACZ;;EAEA;;;;IAIE;EACF;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;;IAEE,wDAAwD;EAC1D;;EAEA;;IAEE,WAAW;EACb;;EAEA;;;;;;;;IAQE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,8FAA8F;AAC9F;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* Encounter Detail / Encounter Workspace only. Namespaced so list/chart stay unchanged. */\n\n.emr-encdetail,\n.emr-encdetail *,\n.emr-encdetail *::before,\n.emr-encdetail *::after,\n.emr-encdetail-select,\n.emr-encdetail-select *,\n.emr-encdetail-dialog,\n.emr-encdetail-dialog *,\n.emr-encdetail-pane,\n.emr-encdetail-pane *,\n.emr-encdetail-pane *::before,\n.emr-encdetail-pane *::after {\n  border-radius: 0 !important;\n}\n\n.emr-mz-dashboard:has(.emr-encdetail) {\n  height: 100vh;\n  max-height: 100vh;\n  overflow: hidden;\n}\n\n.emr-mz-dashboard:has(.emr-encdetail) > .flex-1 {\n  min-height: 0;\n  overflow: hidden;\n}\n\n/* The app header scrolls its own overflow, so flex would otherwise squash it. */\n.emr-mz-dashboard:has(.emr-encdetail) .emr-mz-header {\n  flex-shrink: 0;\n}\n\n.emr-mz-dashboard .emr-mz-main:has(.emr-encdetail) {\n  padding: 10px 12px 12px !important;\n  max-width: none;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  flex: 1 1 auto;\n}\n\n.emr-encdetail {\n  --emr-encdetail-primary: #1976d2;\n  --emr-encdetail-primary-dark: #0d47a1;\n  --emr-encdetail-text: #212121;\n  --emr-encdetail-muted: #616161;\n  --emr-encdetail-border: #e0e0e0;\n  --emr-encdetail-surface: #ffffff;\n  --emr-encdetail-close: #0d5c4d;\n  --emr-encdetail-close-dark: #0a4b3f;\n  max-width: none;\n  margin: 0;\n  min-width: 0;\n  width: 100%;\n  box-sizing: border-box;\n  color: var(--emr-encdetail-text);\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  height: 100%;\n  max-height: 100%;\n  overflow: hidden;\n}\n\n.emr-encdetail__pagehead {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n  min-width: 0;\n  flex-shrink: 0;\n}\n\n.emr-mz-dashboard .emr-encdetail__title,\n.emr-encdetail__title {\n  margin: 0;\n  font-size: var(--emr-type-page-title) !important;\n  font-weight: 600;\n  line-height: 1.25;\n  color: var(--emr-encdetail-text);\n}\n\n.emr-encdetail__subtitle {\n  margin: 2px 0 0;\n  font-size: var(--emr-type-helper);\n  font-weight: 400;\n  color: var(--emr-encdetail-muted);\n}\n\n.emr-encdetail a.emr-encdetail__back,\n.emr-encdetail__back {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  margin-top: 4px;\n  font-size: var(--emr-type-label);\n  font-weight: 600;\n  color: var(--emr-encdetail-primary) !important;\n  text-decoration: none;\n}\n\n.emr-encdetail__back:hover {\n  text-decoration: underline;\n}\n\n.emr-encdetail__back-icon {\n  width: 14px;\n  height: 14px;\n}\n\n.emr-encdetail__head-actions {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.emr-mz-dashboard .btn.emr-encdetail__secondary,\n.emr-encdetail__secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 12px;\n  margin: 0;\n  background: #fff !important;\n  color: var(--emr-encdetail-primary) !important;\n  border: 1px solid var(--emr-encdetail-border);\n  box-shadow: none;\n}\n\n.emr-mz-dashboard .btn.emr-encdetail__secondary:hover,\n.emr-encdetail__secondary:hover {\n  border-color: var(--emr-encdetail-primary);\n  background: #e3f2fd !important;\n}\n\n.emr-mz-dashboard .btn.emr-encdetail__primary,\n.emr-encdetail__primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 14px;\n  margin: 0;\n  background: var(--emr-encdetail-primary) !important;\n  color: #fff !important;\n  border: 1px solid var(--emr-encdetail-primary);\n  box-shadow: none;\n}\n\n.emr-mz-dashboard .btn.emr-encdetail__primary:hover,\n.emr-mz-dashboard .btn.emr-encdetail__primary:focus,\n.emr-encdetail__primary:hover,\n.emr-encdetail__primary:focus {\n  background: var(--emr-encdetail-primary-dark) !important;\n  border-color: var(--emr-encdetail-primary-dark);\n}\n\n.emr-mz-dashboard .btn.emr-encdetail__close,\n.emr-encdetail__close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 36px;\n  min-width: 10.5rem;\n  padding: 0 14px;\n  margin: 0;\n  background: var(--emr-encdetail-close) !important;\n  color: #fff !important;\n  border: 1px solid var(--emr-encdetail-close);\n  box-shadow: none;\n  font-size: var(--emr-type-button-compact);\n  font-weight: var(--emr-weight-title);\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.emr-mz-dashboard .btn.emr-encdetail__close:hover,\n.emr-encdetail__close:hover {\n  background: var(--emr-encdetail-close-dark) !important;\n  border-color: var(--emr-encdetail-close-dark);\n}\n\n.emr-mz-dashboard .btn.emr-encdetail__reopen,\n.emr-encdetail__reopen {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 36px;\n  min-width: 10.5rem;\n  padding: 0 14px;\n  margin: 0;\n  background: #fff !important;\n  color: var(--emr-encdetail-close) !important;\n  border: 1px solid var(--emr-encdetail-close);\n  box-shadow: none;\n  font-size: var(--emr-type-button-compact);\n  font-weight: var(--emr-weight-title);\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.emr-mz-dashboard .btn.emr-encdetail__reopen:hover,\n.emr-encdetail__reopen:hover {\n  background: #eefaf5 !important;\n}\n\n.emr-mz-dashboard .btn.emr-encdetail__primary:disabled,\n.emr-mz-dashboard .btn.emr-encdetail__secondary:disabled,\n.emr-mz-dashboard .btn.emr-encdetail__close:disabled,\n.emr-mz-dashboard .btn.emr-encdetail__reopen:disabled,\n.emr-encdetail__primary:disabled,\n.emr-encdetail__secondary:disabled {\n  opacity: 0.55;\n  pointer-events: none;\n}\n\n.emr-encdetail__icon {\n  width: 14px;\n  height: 14px;\n}\n\n.emr-encdetail__modules {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n  min-height: 0;\n  flex: 1 1 auto;\n  overflow: hidden;\n}\n\n.emr-encdetail__module {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.emr-encdetail__section {\n  margin: 0;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n  background: var(--emr-encdetail-surface);\n  border: 1px solid var(--emr-encdetail-border);\n  box-shadow: none;\n  padding: 8px 12px 10px;\n}\n\n.emr-encdetail__section-title {\n  margin: 0 0 6px;\n  font-size: var(--emr-type-metadata) !important;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--emr-encdetail-muted);\n}\n\n.emr-encdetail__facts {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 6px 16px;\n  min-width: 0;\n}\n\n.emr-encdetail__fact-label {\n  font-size: var(--emr-type-label);\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--emr-encdetail-muted);\n  line-height: 1.2;\n}\n\n.emr-encdetail__fact-value {\n  margin-top: 1px;\n  font-size: var(--emr-type-body);\n  font-weight: 600;\n  color: var(--emr-encdetail-text);\n  line-height: var(--emr-leading-compact);\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.emr-encdetail__patient-head {\n  display: flex;\n  min-width: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px 12px;\n  padding: 6px 8px;\n  margin-bottom: 6px;\n  background: #fafbfc;\n  border: 1px solid var(--emr-encdetail-border);\n}\n\n/* Compact patient identity, always visible above the encounter bar in the\n   Documentation column — even when the Patient Chart column is collapsed. */\n.emr-encdetail__identity-bar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  background: #fafbfc;\n  border-bottom: 1px solid var(--emr-encdetail-border);\n}\n\n.emr-encdetail__identity-expand {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  height: 28px;\n  width: 28px;\n  padding: 0;\n  margin: 0;\n  background: #fff;\n  color: var(--emr-encdetail-primary);\n  border: 1px solid var(--emr-encdetail-border);\n  cursor: pointer;\n}\n\n.emr-encdetail__identity-expand:hover {\n  background: #e3f2fd;\n  border-color: var(--emr-encdetail-primary);\n}\n\n.emr-encdetail__identity-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.emr-encdetail__identity-name {\n  font-size: var(--emr-type-section-title);\n  font-weight: var(--emr-weight-title);\n  color: var(--emr-encdetail-text);\n}\n\n.emr-encdetail__identity-meta {\n  margin-top: 2px;\n  font-size: var(--emr-type-helper);\n  font-weight: 600;\n  color: var(--emr-encdetail-muted);\n}\n\n.emr-encdetail__identity-sep {\n  margin: 0 6px;\n  color: var(--emr-encdetail-border);\n}\n\n.emr-encdetail__patient-name {\n  font-size: var(--emr-type-body);\n  font-weight: 600;\n  color: var(--emr-encdetail-text);\n}\n\n.emr-encdetail__chip {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 8px;\n  font-size: var(--emr-type-metadata);\n  font-weight: 600;\n  border: 0;\n}\n\n.emr-encdetail__chip--active {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.emr-encdetail__chip--inactive {\n  background: #eceff1;\n  color: #546e7a;\n}\n\n.emr-encdetail__chip--finished {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.emr-encdetail__chip--progress {\n  background: #e3f2fd;\n  color: #0d47a1;\n}\n\n.emr-encdetail__chip--neutral {\n  background: #eceff1;\n  color: #455a64;\n}\n\n.emr-encdetail__chip--signed {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.emr-encdetail__chip--draft {\n  background: #fff8e1;\n  color: #ef6c00;\n}\n\n.emr-encdetail__hint {\n  margin: 0;\n  font-size: var(--emr-type-helper);\n  color: var(--emr-encdetail-muted);\n}\n\n.emr-encdetail__rows {\n  display: grid;\n  gap: 4px;\n}\n\n.emr-encdetail__row {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  min-width: 0;\n  font-size: var(--emr-type-body);\n}\n\n.emr-encdetail__row dt {\n  color: var(--emr-encdetail-muted);\n  font-weight: 400;\n}\n\n.emr-encdetail__row dd {\n  margin: 0;\n  font-weight: 600;\n  color: var(--emr-encdetail-text);\n  text-align: right;\n  min-width: 0;\n}\n\n.emr-encdetail__muted {\n  margin: 6px 0 0;\n  font-size: var(--emr-type-helper);\n  color: var(--emr-encdetail-muted);\n}\n\n.emr-encdetail__focus-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  gap: 6px;\n}\n\n.emr-encdetail__focus-item {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: var(--emr-type-body);\n}\n\n.emr-encdetail__focus-code {\n  flex-shrink: 0;\n  font-size: var(--emr-type-metadata);\n  color: var(--emr-encdetail-muted);\n}\n\n.emr-encdetail__workspace {\n  flex: 1 1 auto;\n  min-height: 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  overflow: hidden;\n}\n\n/*\n * `.emr-mz-dashboard section` forces display:block at a higher specificity than\n * Tailwind's .flex, so the pane must claim its flex column here. Without this\n * the height chain down to .emr-note-rtf__surface is not definite.\n */\n.emr-mz-dashboard .emr-encdetail__pane,\n.emr-encdetail__pane {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  overflow: hidden;\n  background: var(--emr-encdetail-surface);\n  border: 1px solid var(--emr-encdetail-border);\n  box-shadow: none;\n}\n\n.emr-encdetail__pane-head {\n  flex-shrink: 0;\n  padding: 6px 10px;\n  border-bottom: 1px solid var(--emr-encdetail-border);\n}\n\n/* Patient Chart tab strip + collapse control, at the top of the left column. */\n.emr-encdetail__chart-tabs-row {\n  display: flex;\n  flex-shrink: 0;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  border-bottom: 1px solid var(--emr-encdetail-border);\n}\n\n.emr-encdetail__chart-tabs-row .chart-subtabs {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.emr-encdetail__chart-collapse-btn {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  width: 32px;\n  margin: 4px 6px 0 0;\n  padding: 0;\n  background: #fff;\n  color: var(--emr-encdetail-muted);\n  border: 1px solid var(--emr-encdetail-border);\n  cursor: pointer;\n}\n\n.emr-encdetail__chart-collapse-btn:hover {\n  background: #e3f2fd;\n  color: var(--emr-encdetail-primary-dark);\n  border-color: var(--emr-encdetail-primary);\n}\n\n.emr-encdetail__chart-body {\n  display: flex;\n  flex-direction: column;\n}\n\n.emr-encdetail__pane-body {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  padding: 8px;\n}\n\n/*\n * The Notes pane never scrolls its own note content: the contenteditable RTF\n * surface is the note scrollport. This keeps a definite height chain from the\n * 100vh shell down to .emr-note-rtf__surface.\n */\n.emr-encdetail__pane-body--notes {\n  overflow: hidden;\n}\n\n.emr-encdetail__pane-title {\n  margin: 0;\n  font-size: var(--emr-type-metadata) !important;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--emr-encdetail-muted);\n}\n\n.emr-encdetail__pane-toggle {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 10px;\n  margin: 0;\n  border: 0;\n  background: #fff;\n  text-align: left;\n  cursor: pointer;\n}\n\n.emr-encdetail__pane-toggle-meta {\n  font-size: var(--emr-type-metadata);\n  color: var(--emr-encdetail-muted);\n}\n\n.emr-encdetail__restore {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n  color: var(--emr-encdetail-muted);\n  border: 0;\n  cursor: pointer;\n}\n\n.emr-encdetail__restore:hover {\n  background: #e3f2fd;\n  color: var(--emr-encdetail-primary-dark);\n}\n\n.emr-encdetail__restore-label {\n  margin-top: 12px;\n  font-size: var(--emr-type-micro);\n  font-weight: 600;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: inherit;\n  writing-mode: vertical-rl;\n}\n\n.emr-encdetail__divider {\n  position: relative;\n  z-index: 10;\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  cursor: col-resize;\n}\n\n.emr-encdetail__divider-line {\n  height: 100%;\n  width: 1px;\n  background: var(--emr-encdetail-border);\n}\n\n.emr-encdetail__divider:hover .emr-encdetail__divider-line {\n  background: #90a4ae;\n}\n\n.emr-encdetail__divider-grip {\n  pointer-events: none;\n  position: absolute;\n  height: 32px;\n  width: 4px;\n  background: #b0bec5;\n  opacity: 0;\n}\n\n.emr-encdetail__divider:hover .emr-encdetail__divider-grip {\n  opacity: 1;\n}\n\n.emr-encdetail__status-msg {\n  padding: 28px 16px;\n  text-align: center;\n  font-size: var(--emr-type-body);\n  color: var(--emr-encdetail-muted);\n}\n\n.emr-encdetail__empty {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 28px 16px;\n  text-align: center;\n  border: 1px dashed var(--emr-encdetail-border);\n  background: #fff;\n}\n\n.emr-encdetail__empty-title {\n  margin: 0;\n  font-size: var(--emr-type-label);\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--emr-encdetail-text);\n}\n\n.emr-encdetail__empty-copy {\n  margin: 6px 0 0;\n  font-size: var(--emr-type-helper);\n  color: var(--emr-encdetail-muted);\n}\n\n.emr-encdetail__empty-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n/* Compact encounter identification/status strip at the top of the main workspace. */\n.emr-encdetail__encounter-bar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 12px;\n  background: #fafbfc;\n  border-bottom: 1px solid var(--emr-encdetail-border);\n}\n\n.emr-encdetail__encounter-bar-facts {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.emr-encdetail__encounter-bar-label {\n  font-size: var(--emr-type-label);\n  font-weight: var(--emr-weight-label);\n  color: var(--emr-encdetail-text);\n  white-space: nowrap;\n}\n\n.emr-encdetail__encounter-bar-value {\n  font-size: var(--emr-type-body);\n  font-weight: 600;\n  color: var(--emr-encdetail-text);\n  white-space: nowrap;\n}\n\n.emr-encdetail__encounter-bar-sep {\n  color: var(--emr-encdetail-border);\n}\n\n.emr-encdetail__encounter-bar-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.emr-encdetail__notes-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 2px 6px 0;\n}\n\n.emr-encdetail__notes-title {\n  font-size: var(--emr-type-card-title);\n  font-weight: 600;\n  color: var(--emr-encdetail-text);\n}\n\n.emr-encdetail__notes-tabs {\n  display: flex;\n  align-items: flex-end;\n  gap: 2px;\n  min-width: 0;\n}\n\n.emr-encdetail__notes-tab {\n  padding: 5px 12px;\n  margin: 0;\n  border: 1px solid transparent;\n  border-bottom: 0;\n  background: transparent;\n  color: var(--emr-encdetail-muted);\n  font-size: var(--emr-type-button-compact);\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.emr-encdetail__notes-tab:hover {\n  color: var(--emr-encdetail-primary-dark);\n}\n\n.emr-encdetail__notes-tab--active {\n  margin-bottom: -1px;\n  border-color: var(--emr-encdetail-border);\n  background: #fff;\n  color: var(--emr-encdetail-primary-dark);\n}\n\n/* Right-side collapsible Diagnosis / CPT Code / Order panel. */\n.emr-encdetail__coding {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-height: 0;\n  min-width: 0;\n}\n\n.emr-encdetail__coding-tabs-row {\n  display: flex;\n  flex-shrink: 0;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  border-bottom: 1px solid var(--emr-encdetail-border);\n}\n\n.emr-encdetail__coding-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 2px;\n  min-width: 0;\n  padding: 6px 6px 0;\n}\n\n.emr-encdetail__coding-tab {\n  padding: 5px 12px;\n  margin: 0;\n  border: 1px solid transparent;\n  border-bottom: 0;\n  background: transparent;\n  color: var(--emr-encdetail-muted);\n  font-size: var(--emr-type-button-compact);\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.emr-encdetail__coding-tab:hover {\n  color: var(--emr-encdetail-primary-dark);\n}\n\n.emr-encdetail__coding-tab--active {\n  margin-bottom: -1px;\n  border-color: var(--emr-encdetail-border);\n  background: #fff;\n  color: var(--emr-encdetail-primary-dark);\n}\n\n.emr-encdetail__coding-body {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 12px;\n  background: #fff;\n}\n\n.emr-encdetail__coding-empty {\n  padding: 28px 16px;\n  text-align: center;\n  font-size: var(--emr-type-helper);\n  color: var(--emr-encdetail-muted);\n}\n\n.emr-mz-dashboard .btn.emr-encdetail__new-note,\n.emr-encdetail__new-note {\n  height: 28px;\n  padding: 0 10px;\n  font-size: var(--emr-type-button-compact);\n}\n\n.emr-encdetail__notes {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n  min-height: 0;\n  width: 100%;\n}\n\n.emr-encdetail__notes-panel {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n  min-height: 0;\n  /* Fallback only: on very short viewports the editor keeps its min height and\n     this panel scrolls instead of collapsing the writing area to nothing. */\n  overflow-y: auto;\n}\n\n.emr-encdetail__notes-panel--scroll {\n  overflow-y: auto;\n}\n\n.emr-encdetail__notes-panel--empty {\n  justify-content: center;\n  align-items: center;\n}\n\n.emr-encdetail__current {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 10px;\n  background: #fafbfc;\n  border: 1px solid var(--emr-encdetail-border);\n}\n\n.emr-encdetail__current-title {\n  font-size: var(--emr-type-card-title);\n  font-weight: 600;\n  color: var(--emr-encdetail-text);\n}\n\n.emr-encdetail__current-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin-top: 2px;\n  font-size: var(--emr-type-helper);\n  color: var(--emr-encdetail-muted);\n}\n\n.emr-encdetail__current-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.emr-encdetail__editor {\n  min-height: 16rem;\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid var(--emr-encdetail-border);\n  background: #fff;\n  font-size: var(--emr-type-body);\n  line-height: 1.45;\n  color: var(--emr-encdetail-text);\n  resize: vertical;\n}\n\n.emr-encdetail__editor:focus {\n  border-color: var(--emr-encdetail-primary);\n  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.18);\n  outline: none;\n}\n\n.emr-encdetail__editor[readonly],\n.emr-encdetail__editor--locked {\n  background: #fafbfc;\n  cursor: not-allowed;\n}\n\n.emr-encdetail__editor--rtf {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  padding: 0;\n  resize: none;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.emr-encdetail__editor--rtf.emr-encdetail__editor--locked {\n  cursor: default;\n}\n\n.emr-note-rtf {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.emr-note-rtf__toolbar {\n  display: flex;\n  flex: 0 0 auto;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 1px;\n  min-height: 32px;\n  padding: 2px 6px;\n  border-bottom: 1px solid var(--emr-encdetail-border);\n  background: #f8fafc;\n}\n\n.emr-note-rtf__label {\n  margin-right: 4px;\n  padding-right: 6px;\n  border-right: 1px solid #e2e8f0;\n  color: #64748b;\n  font-size: var(--emr-type-metadata);\n  font-weight: var(--emr-weight-title);\n  letter-spacing: 0.04em;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.emr-note-rtf__sep {\n  width: 1px;\n  height: 16px;\n  margin: 0 4px;\n  background: #e2e8f0;\n}\n\n.emr-note-rtf__select {\n  height: 26px;\n  width: auto;\n  max-width: 88px;\n  margin: 0 2px;\n  padding: 0 4px;\n  border: 1px solid #e2e8f0;\n  border-radius: 3px;\n  background: #fff;\n  color: #334155;\n  font-size: var(--emr-type-label);\n}\n\n.emr-note-rtf__extra {\n  margin-left: auto;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 0 2px 6px;\n}\n\n.emr-note-rtf__surface {\n  flex: 1 1 auto;\n  min-width: 0;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 12px 14px;\n  color: var(--emr-encdetail-text);\n  font-size: var(--emr-type-body);\n  line-height: 1.55;\n  outline: none;\n}\n\n.emr-note-rtf__surface:empty:before {\n  content: attr(data-placeholder);\n  color: #94a3b8;\n  white-space: pre-wrap;\n  pointer-events: none;\n}\n\n.emr-note-rtf__surface--locked {\n  background: #fafbfc;\n  cursor: default;\n}\n\n.emr-note-rtf__surface p,\n.emr-note-rtf__surface div {\n  margin: 0 0 0.25em;\n}\n\n.emr-note-rtf__surface ul,\n.emr-note-rtf__surface ol {\n  margin: 0 0 0.25em 1.2em;\n  padding: 0;\n}\n\n.emr-encdetail__notes-body {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n  min-height: 0;\n}\n\n.emr-encdetail__notes-main {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n}\n\n.emr-encdetail__editor-wrap {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 12rem;\n}\n\n.emr-encdetail__autosave {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 12px;\n  padding-top: 4px;\n  font-size: var(--emr-type-metadata);\n  color: var(--emr-encdetail-muted);\n}\n\n.emr-encdetail__autosave-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  background: #66bb6a;\n}\n\n.emr-encdetail__autosave-dot--off {\n  background: #bdbdbd;\n}\n\n.emr-encdetail__orders {\n  padding: 16px 12px;\n  text-align: center;\n  border: 1px dashed var(--emr-encdetail-border);\n  background: #fff;\n}\n\n.emr-encdetail__orders-icon {\n  display: flex;\n  width: 32px;\n  height: 32px;\n  margin: 0 auto 8px;\n  align-items: center;\n  justify-content: center;\n  background: #e3f2fd;\n  color: var(--emr-encdetail-primary);\n}\n\n.emr-encdetail__orders h2 {\n  margin: 0;\n  font-size: var(--emr-type-card-title) !important;\n  font-weight: 600;\n  color: var(--emr-encdetail-text);\n}\n\n.emr-encdetail-dialog {\n  border: 1px solid var(--emr-encdetail-border, #e0e0e0) !important;\n  border-radius: 0 !important;\n  background: #fff !important;\n  box-shadow: none !important;\n}\n\n.emr-encdetail-select {\n  border-radius: 0 !important;\n  border: 1px solid var(--emr-encdetail-border, #e0e0e0) !important;\n  background: #fff !important;\n  box-shadow: none !important;\n}\n\n/* Nested clinical cards inside Notes inherit sharp Materialize modules. */\n.emr-encdetail [data-testid=\"encounter-screen-soap-editor\"],\n.emr-encdetail [data-testid=\"encounter-screen-note-list\"],\n.emr-encdetail [data-testid=\"encounter-screen-diagnosis-workspace\"] section,\n.emr-encdetail [data-testid=\"encounter-screen-cpt\"] {\n  border-color: var(--emr-encdetail-border) !important;\n  box-shadow: none !important;\n}\n\n.emr-encdetail [data-testid=\"encounter-screen-soap-editor\"] {\n  min-height: 0;\n}\n\n@media only screen and (min-width: 601px) {\n  .emr-encdetail__facts {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media only screen and (min-width: 1024px) {\n  .emr-encdetail__module {\n    height: 100%;\n  }\n\n  .emr-encdetail__facts {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media only screen and (min-width: 1440px) {\n  .emr-encdetail__facts {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n\n@media only screen and (max-width: 1023px) {\n  .emr-mz-dashboard:has(.emr-encdetail) {\n    height: auto;\n    max-height: none;\n    overflow: visible;\n  }\n\n  .emr-mz-dashboard:has(.emr-encdetail) > .flex-1 {\n    min-height: 0;\n    overflow: visible;\n  }\n\n  .emr-mz-dashboard .emr-mz-main:has(.emr-encdetail) {\n    overflow: visible;\n    display: block;\n    min-height: 0;\n  }\n\n  .emr-encdetail {\n    height: auto;\n    max-height: none;\n    overflow: visible;\n    min-height: 0;\n  }\n\n  .emr-encdetail__modules,\n  .emr-encdetail__workspace {\n    overflow: visible;\n    min-height: 0;\n    flex: none;\n  }\n\n  /*\n   * Stacked mode has no definite height chain, so give the editor an explicit\n   * viewport share. Without this the contenteditable grows to its content and\n   * the page becomes the note scrollport.\n   */\n  .emr-encdetail__notes-panel {\n    overflow: visible;\n  }\n\n  .emr-encdetail__editor-wrap {\n    flex: none;\n    height: 60vh;\n    min-height: 20rem;\n  }\n}\n\n@media only screen and (max-width: 899px) {\n  .emr-encdetail__pagehead {\n    flex-wrap: wrap;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .emr-encdetail__pagehead {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n  }\n\n  .emr-mz-dashboard .emr-encdetail__title,\n  .emr-encdetail__title {\n    font-size: var(--emr-type-page-title-compact) !important;\n  }\n\n  .emr-encdetail__head-actions,\n  .emr-encdetail__current-actions {\n    width: 100%;\n  }\n\n  .emr-mz-dashboard .btn.emr-encdetail__primary,\n  .emr-mz-dashboard .btn.emr-encdetail__secondary,\n  .emr-mz-dashboard .btn.emr-encdetail__close,\n  .emr-mz-dashboard .btn.emr-encdetail__reopen,\n  .emr-encdetail__primary,\n  .emr-encdetail__secondary,\n  .emr-encdetail__close,\n  .emr-encdetail__reopen {\n    flex: 1 1 auto;\n    width: auto;\n    min-width: 0;\n  }\n\n  .emr-encdetail__facts {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .emr-encdetail__section {\n    padding: 8px 10px;\n  }\n\n  .emr-encdetail {\n    min-height: 0;\n  }\n}\n\n/* Encounter Detail now sits in Materialize chrome; keep the print article hidden on screen. */\n.emr-mz-dashboard article.note-print-root {\n  display: none !important;\n}\n\n@media print {\n  .emr-mz-dashboard article.note-print-root {\n    display: block !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
